import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Checkbox, Form, TextField } from "../../../components/forms";
import ViewTestimonialsDrawer from "./ViewTestimonialsDrawer";
import OTPVerificationPopup from "./OTPVerificationPopup";
import { customSelectStyles } from "../../../constants/styles";
import Select from "react-select";
import { useLazyGetOtpCodeQuery } from "../../../services/callbackService";
import { toast } from "react-toastify";
import parseError from "../../../utils/errorUtils";
import {
  useAddHubSpotMutation,
  useUpdateHubSpotMutation
} from "../../../services/dataService"

const BasicInfoForm = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [count, setCount] = useState(900);
  const [firstSubmit, setFirstSubmit] = useState(false);
  const genderOptions = [
    { value: "0", label: "Male" },
    { value: "1", label: "Female" },
  ];
  const savedValues = JSON.parse(
    localStorage.getItem("EligibilityForm") || "null"
  );
  const [gender, setGender] = useState(
    genderOptions.find(data => data.label.toLowerCase() === savedValues?.["Gender at birth"].toLowerCase())
  );
  const [isMobile, setIsMobile] = useState(false);
  const [getOtpCode] = useLazyGetOtpCodeQuery();
  const [addHubSpot] = useAddHubSpotMutation();
  const [updateHubSpot] = useUpdateHubSpotMutation();

  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };

  const toggleOTPModal = () => {
    setShowOTPModal((prev) => !prev);
  };

  const [email, setEmail] = useState(savedValues?.["Email address"] || "");
  const [firstName, setFirstName] = useState(savedValues?.["First name"] || "");
  const [lastName, setLastName] = useState(savedValues?.["Last name"] || "");
  const [phoneNumber, setPhoneNumber] = useState(savedValues?.["Phone number"] || "");

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleFirstNameChange = (e) => setFirstName(e.target.value);
  const handleLastNameChange = (e) => setLastName(e.target.value);
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
  };

  const fieldsValidity = !email || !firstName || !lastName || !phoneNumber || !gender || phoneNumber.length === 3;

  const handleOnBack = () => navigate(-1);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email address is required")
      .email("Please enter a valid email address"),
    firstName: Yup.string()
      .required("First name is required")
      .min(2, "First name must be at least 2 characters")
      .matches(/^[A-Za-z\s]*$/, "First name can only contain letters"),
    lastName: Yup.string()
      .required("Last name is required")
      .min(2, "Last name must be at least 2 characters")
      .matches(/^[A-Za-z\s]*$/, "Last name can only contain letters"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .test("starts-with-plus", "Country code is required (e.g., +44)", (value) =>
        /^\+/.test(value || "")
      )
      .test("valid-length", "Please enter a valid phone number", (value) =>
        /^\+[0-9]{11,13}$/.test(value || "")
      ),
  });

  const initialValues = {
    email: savedValues?.["Email address"] || "",
    firstName: savedValues?.["First name"] || "",
    lastName: savedValues?.["Last name"] || "",
    phoneNumber: savedValues?.["Phone number"] || "+44",
    consent: savedValues?.["consent"] || false,
  };

  const handleSubmit = async (values) => {
    setFirstSubmit(true)
    const objectData = {
      ...savedValues,
      "Email address": values.email,
      "First name": values.firstName,
      "Last name": values.lastName,
      "Phone number": values.phoneNumber,
      "Gender at birth": gender.label.toUpperCase(),
      consent: values.consent,
    };

    const data = JSON.stringify({ ...objectData });
    localStorage.setItem("EligibilityForm", data);
    await submitHubSpot(values);
  };

  const sendOtpCode = async (values) => {
    //values will be undefined when re-send otp
    let isNumberChanged = false;
    if (values) {
      isNumberChanged = values.phoneNumber !== initialValues.phoneNumber
    }
    if (count === 900 || values === undefined || isNumberChanged) {
      try {
        const res = await getOtpCode({
          phoneNumber: values?.phoneNumber || savedValues?.["Phone number"],
          name: values?.firstName || savedValues?.["First name"]
        });
        if (res.error) {
          toast.error(parseError(res.error, "Failed to send verification code"));
        } else {
          !isMobile && toast.success("Verification code sent");
        }
      } catch (error) { }
    }
  }

  const handleContinue = async (values) => {
    // let isNumberChanged = false;
    // if (values) {
    //   isNumberChanged = values.phoneNumber !== initialValues.phoneNumber
    // }
    // if (localStorage.getItem("isOtpVerified") && !isNumberChanged) {
      navigate("/onboarding/eligibility-flow/age", { replace: true })
    // } else {
    //   try {
    //     await validationSchema.validate(values, { abortEarly: false });

    //     const savedTimestamp = localStorage.getItem("otpTimestamp");
    //     const currentTime = Date.now();
    //     const elapsedSeconds = savedTimestamp
    //       ? Math.floor((currentTime - Number(savedTimestamp)) / 1000)
    //       : null;

    //     if (!savedTimestamp || elapsedSeconds >= 900) {
    //       localStorage.setItem("otpTimestamp", currentTime);
    //     }

    //     await sendOtpCode(values);
    //     setShowOTPModal(true);
    //   } catch (error) {
    //     console.log("Form is invalid:", error.errors);
    //   }
    // }
  };

  const submitHubSpot = async (values) => {
    const vid = localStorage.getItem("vid")
    try {
      let data = {
        properties: [
          {
            property: "email",
            value: values.email
          },
          {
            property: "firstname",
            value: `${values.firstName}`
          },
          {
            property: "lastname",
            value: values.lastName
          },
          {
            property: "gender",
            value: gender.label
          },
          {
            property: "phone",
            value: values.phoneNumber
          },
          {
            property: "website",
            value: localStorage.getItem("baseUrl") || ""
          },
          {
            property: "slot_id",
            value: localStorage.getItem("appointment_date") + " " + localStorage.getItem("appointment_time")
          },
          {
            property: "consent_check",
            value: values.consent ? "Yes" : "No"
          },
          {
            property: "payment",
            value: "Pending"
          },
          {
            property: "type",
            value: "ELIGIBILITY"
          }
        ]
      };

      const res = !vid && await addHubSpot({ values: data });
      const updateRes = vid && await updateHubSpot({ values: data, vid: vid})

      if (res.data.status === "Success") {
        localStorage.setItem("vid", res.data.data.vid)
      } else {
        console.error("hubspot faild")
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    setIsMobile(isMobile);
  }, []);

  return (
    <div className="d-flex flex-column h-100">
      <h4 className="mb-2 fw-bold">Let's start with a little about you</h4>
      <p className="text-gray-1 mb-3">
        To get started with a free eligibility check, enter the details below
      </p>
      <div className="d-flex mt-4 h-100">
        <Form
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            gender && handleSubmit(values);
            gender && handleContinue(values);
          }}
          enableReinitialize
          className="d-flex"
        >
          <div className="container px-0 d-flex flex-column justify-content-between">
            <div className="column col-md-12 col-lg-12 col-xl-9">
              <div className="row mb-4">
                <div className="col-md-12">
                  <label className="mb-2">
                    Email address<span className="text-red-1">*</span>
                  </label>
                  <TextField
                    name="email"
                    type="email"
                    onChange={handleEmailChange}
                    placeholder="Enter your email address"
                    autoComplete="no"
                    className="p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder "
                  />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12 col-lg-6 mb-3 mb-lg-0">
                  <label className="mb-2">
                    First name<span className="text-red-1">*</span> (as
                    displayed on an ID)
                  </label>
                  <TextField
                    name="firstName"
                    onChange={handleFirstNameChange}
                    placeholder="Enter your first name"
                    autoComplete="no"
                    className="p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder"
                  />
                </div>
                <div className="col-md-12 col-lg-6">
                  <label className="mb-2">
                    Last name<span className="text-red-1">*</span> (as displayed
                    on an ID)
                  </label>
                  <TextField
                    name="lastName"
                    onChange={handleLastNameChange}
                    placeholder="Enter your last name"
                    autoComplete="no"
                    className="p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder"
                  />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12 col-lg-6 mb-3 mb-lg-0">
                  <label className="mb-2">
                    Phone number<span className="text-red-1">*</span>
                  </label>
                  <TextField
                    name="phoneNumber"
                    onChange={handlePhoneNumberChange}
                    placeholder="Enter your phone number"
                    autoComplete="no"
                    className="p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder"
                    onKeyDown={(e) => {
                      const inputValue = e.currentTarget.value;
                      const allowedKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];
                      if (
                        (!/[0-9]/.test(e.key) && e.key !== "+" && !allowedKeys.includes(e.key)) ||
                        // (e.key === "+" && e.target.selectionStart !== 0)
                        (inputValue.length <= 3 && e.key === "Backspace")
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className="col-md-12 col-lg-6">
                  <label className="mb-2">
                    Gender at birth<span className="text-red-1">*</span>
                  </label>
                  <Select
                    name="gender"
                    placeholder="Select"
                    styles={customSelectStyles}
                    errorClass="error-text mt-1"
                    options={genderOptions}
                    onChange={(option) => {
                      setGender(option);
                    }}
                    value={gender}
                  />
                  {gender === undefined && firstSubmit && (
                    <label className="text-danger mt-1">
                      Gender is required
                    </label>
                  )}
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <Checkbox
                    label="I consent to receiving special offers and general medical information from Treat-It via Call, SMS, WhatsApp and email. (optional)"
                    name="consent"
                    className="check-lg"
                    inputClass="rounded"
                    labelClass="ms-3"
                  />
                </div>
              </div>
            </div>
            <div className="column fixed-footer">
              <div className="d-flex flex-column flex-lg-row gap-md-4 gap-lg-5 justify-content-between align-items-center align-items-md-end align-items-lg-center inner-footer">
                <p className="privacy-text mb-12 mb-md-0">
                  By creating your account, you confirm you have read and accepted
                  the{" "}
                  <a
                    href="https://treat-it.clinic/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 fw-semibold text-decoration-underline"
                  >
                    Privacy Policy
                  </a>{" "}
                  and the{" "}
                  <a
                    href="https://treat-it.clinic/terms-conditions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 fw-semibold text-decoration-underline"
                  >
                    Terms and Conditions.
                  </a>
                </p>
                <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0">
                  <button
                    className="d-none d-md-block text-primary-600 bg-transparent py-2 px-4 w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
                    onClick={handleOnBack}
                    type="button"
                  >
                    <p className="mb-0 fw-bold fs-6">Back</p>
                  </button>
                  <button
                    className="d-block d-md-none text-primary-600 bg-transparent pt-2 pb-0 px-4 w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
                    type="button"
                    onClick={toggleModal}
                  >
                    <p className="mb-0 fw-bold fs-6">
                      View testimonials
                    </p>
                  </button>
                  <button
                    className={`bg-primary-600 text-white py-2 px-5 w-100 w-md-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap ${fieldsValidity
                      ? "opacity-50 cursor-not-allowed"
                      : "opacity-100 cursor-pointer"
                      }`}
                    type="submit"
                    onClick={() => setFirstSubmit(true)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <ViewTestimonialsDrawer show={showModal} onClose={toggleModal} />
      {showOTPModal &&
        <OTPVerificationPopup
          show={showOTPModal}
          onClose={toggleOTPModal}
          reSendOtp={sendOtpCode}
          count={count}
          setCount={setCount}
        />
      }
    </div>
  );
};

export default BasicInfoForm;
